import { Controller } from "@hotwired/stimulus"

type CeremonyMode = "create" | "get"

export default class extends Controller<HTMLFormElement> {
  static targets = ["credential", "error"]
  static values = { mode: String, options: Object, auto: Boolean }

  declare readonly credentialTarget: HTMLInputElement
  declare readonly errorTarget: HTMLElement
  declare readonly modeValue: CeremonyMode
  declare readonly optionsValue: PublicKeyCredentialCreationOptionsJSON | PublicKeyCredentialRequestOptionsJSON
  declare readonly autoValue: boolean

  connect(): void {
    if (this.autoValue) this.element.requestSubmit()
  }

  async perform(event: SubmitEvent): Promise<void> {
    if (this.credentialTarget.value !== "") return

    event.preventDefault()
    try {
      const credential = await this.ceremony()
      this.credentialTarget.value = JSON.stringify(credential.toJSON())
      this.element.requestSubmit()
    } catch (error) {
      this.showError(error)
    }
  }

  private async ceremony(): Promise<PublicKeyCredential> {
    const credential = this.modeValue === "create"
      ? await navigator.credentials.create({ publicKey: PublicKeyCredential.parseCreationOptionsFromJSON(this.optionsValue as PublicKeyCredentialCreationOptionsJSON) })
      : await navigator.credentials.get({ publicKey: PublicKeyCredential.parseRequestOptionsFromJSON(this.optionsValue as PublicKeyCredentialRequestOptionsJSON) })

    if (credential === null) throw new Error("No passkey was selected.")
    return credential as PublicKeyCredential
  }

  private showError(error: unknown): void {
    const message = error instanceof DOMException && error.name === "NotAllowedError"
      ? "The passkey request was cancelled or timed out."
      : "Your browser couldn't complete the passkey request."
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("hidden")
  }
}
